export enum CookieExpirePeriod {
  days = 'days',
  minutes = 'minutes',
}
